import { Component } from '@angular/core';

@Component({
  selector: 'ez-past-due-modal',
  templateUrl: './past-due-modal.component.html',
  styleUrls: ['./past-due-modal.component.scss'],
  standalone: false,
})
export class PastDueModalComponent { }
